import * as amplitude from '@amplitude/analytics-browser'
import {getAllAppParams} from './appMetadata'

export const AMPLITUDE_API_KEY =
    process.env.NODE_ENV === 'development'
        ? 'a6e98af5320c34e7273ad2d0707b439f' // "Starpage Solo Dev" key
        : 'f5bc469635be8adc64b81e0c3593eccc' // "Starpage Solo Prod" key

let logged = false
const logAmplitude = (experimentId) => {
    if (logged) return
    logged = true
    amplitude.init(AMPLITUDE_API_KEY, undefined, {
        // Optional configuration
        trackingOptions: {
            deviceManufacturer: false,
            deviceModel: false,
            ipAddress: false,
            language: true,
            osName: true,
            osVersion: true,
            platform: true,
        },
        defaultTracking: true,
        disableCookies: true, // Disables the use of browser cookies
        // Enable logging in development
        // Docs: https://amplitude.com/docs/sdks/analytics/react-native/react-native-sdk#debugging
        logLevel:
            process.env.NODE_ENV === 'development' ? amplitude.Types.LogLevel.Debug : amplitude.Types.LogLevel.Warn,
        // PROXYING OPTIONS:
        serverUrl: 'https://solo-tlm.startpage.com/2/httpapi',
        // serverZone: 'US',
        // useBatch: true,
    })
    const allAppParams = getAllAppParams(experimentId)
    amplitude.logEvent('marketing-landing-page-view', allAppParams)
}

export default logAmplitude
